module.exports = __webpack_public_path__ + "static/media/congrats-ribbon.e0e21c03.png";